module.exports = __webpack_public_path__ + "static/mobile-49ae4cfbaef94b69965e97592bf397e1.png";